


































import { Vue, Component, Prop, Watch, Model } from 'vue-property-decorator';
import debounce from 'lodash/debounce';

interface Element {
    value: any;
    text: string;
    type: string;
}

@Component({})
export default class LocationFilterComponent extends Vue {
    @Prop({ default: () => [] }) fetch!: (value: string) => Promise<Element[]>;
    @Prop() placeholder!: string;
    @Prop() notFoundContent!: string;
    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: false }) multiple!: boolean;
    
    @Model('update:value') readonly value!: any;

    vModel: any[] = [];
    searching: boolean = false;
    items: Element[] = [];
    selectedItemsCache: Map<any, Element> = new Map();
    
    debouncedFetchElements = debounce(this.fetchElements, 400);

    @Watch('value', { immediate: true })
    onValueChange(val: any) {
        this.vModel = Array.isArray(val) ? val : (val ? [val] : []);
    }

    @Watch('vModel')
    onVModelChange(val: any[]) {
        this.$emit('update:value', val);
    }

    onFilterSearch(value: string) {
        this.searching = true;
        this.debouncedFetchElements(value);
    }

    async fetchElements(value: string) {
        if (!value || value.length < 2) {
            this.searching = false;
            return;
        }
        try {
            this.items = await this.fetch(value);
            this.items.forEach(item => {
                this.selectedItemsCache.set(`${item.type}||${item.value}`, item);
            });
        } catch (e) {
            console.error(e);
        } finally {
            this.searching = false;
        }
    }

    onFilter(values: any[]) {
        const selectedItems: Element[] = [];
        
        values.forEach(value => {
            const item = this.selectedItemsCache.get(value);
            if (item) {
                selectedItems.push(item);
            }
        });
        
        this.$emit('change', selectedItems);
    }
    
    isSelected(value: any): boolean {
        return this.vModel.includes(value);
    }
    
    getTypeClass(type: string): string {
        if (!type) return '';
        return 'type-' + type.toLowerCase().replace(/\s+/g, '-');
    }

    mounted() {
        this.vModel = Array.isArray(this.value) ? this.value : (this.value ? [this.value] : []);
    }

    clear() {
        this.vModel = [];
        this.$emit('change', []);
    }
}
